import { s } from '../lib/style.js';

export function Waitlist({ v }) {
  return (
    <section id="waitlist" style={s("scroll-margin-top:80px;background:var(--ink);")}>
      <div style={s("max-width:1220px;margin:0 auto;padding:clamp(56px,6vw,96px) 28px;")}>
        <div
          style={s("position:relative;overflow:hidden;border-radius:32px;background:linear-gradient(160deg,#0B1F23 0%,#123138 48%,#1B4B4A 100%);box-shadow:0 34px 80px rgba(11,31,35,0.30);")}
        >
          <div
            aria-hidden="true"
            style={s("position:absolute;bottom:-360px;left:50%;transform:translateX(-50%);width:100%;max-width:1000px;height:640px;pointer-events:none;background:radial-gradient(50% 50% at 50% 50%,rgba(122,206,192,0.42),transparent 70%);")}
          />
          <div
            aria-hidden="true"
            style={s("position:absolute;bottom:-150px;left:50%;transform:translateX(-50%);width:100%;max-width:420px;height:420px;border-radius:50%;pointer-events:none;background:radial-gradient(circle,rgba(122,206,192,0.30),rgba(122,206,192,0) 68%);")}
          />
          <div
            aria-hidden="true"
            style={s("position:absolute;inset:0;pointer-events:none;opacity:.5;background-image:radial-gradient(rgba(255,255,255,0.14) 1px,transparent 1px);background-size:24px 24px;mask-image:radial-gradient(70% 60% at 50% 20%,#000 20%,transparent 100%);-webkit-mask-image:radial-gradient(70% 60% at 50% 20%,#000 20%,transparent 100%);")}
          />
          <div
            style={s("position:relative;z-index:1;max-width:700px;margin:0 auto;padding:clamp(60px,8vw,116px) clamp(20px,4vw,28px) clamp(64px,7vw,104px);text-align:center;")}
          >
            <div
              style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:15px;letter-spacing:0.18em;text-transform:uppercase;color:#7ACEC0;margin-bottom:18px;")}
            >
              Become a founding design partner
            </div>
            <h2
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(34px,5.2vw,62px);line-height:1.03;letter-spacing:-0.035em;margin:0;color:#FFFFFF;")}
            >
              Let's build a new day for your
              {' '}
              <span style={s(v.kwDark)}>
                brand team.
              </span>
            </h2>
            <p
              style={s("max-width:520px;margin:20px auto 0;font-size:18px;line-height:1.6;color:rgba(234,243,241,0.70);")}
            >
              We're opening BrandBase to a small group of founding CPG brand teams in 2026. Tell us a little about your team.
            </p>
            {v.notSubmitted ? (
              <>
                <form
                  onSubmit={v.onSubmit}
                  style={s("margin:34px auto 0;max-width:540px;display:grid;gap:12px;text-align:left;")}
                >
                  <div
                    style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(200px,100%),1fr));gap:12px;")}
                  >
                    {' '}
                    <input
                      type="text"
                      placeholder="Name"
                      value={v.name}
                      onChange={v.onName}
                      style={s("background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.18);border-radius:12px;padding:15px 18px;font-size:16.5px;color:#FFFFFF;outline:none;width:100%;")}
                    />
                    {' '}
                    <input
                      type="text"
                      placeholder="Company"
                      value={v.company}
                      onChange={v.onCompany}
                      style={s("background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.18);border-radius:12px;padding:15px 18px;font-size:16.5px;color:#FFFFFF;outline:none;width:100%;")}
                    />
                    {' '}
                  </div>
                  {' '}
                  <input
                    type="email"
                    required
                    placeholder="Work email"
                    value={v.email}
                    onChange={v.onEmail}
                    style={s("background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.18);border-radius:12px;padding:15px 18px;font-size:16.5px;color:#FFFFFF;outline:none;width:100%;")}
                  />
                  {' '}
                  <textarea
                    placeholder="What would you like to build with us? (optional)"
                    value={v.message}
                    onChange={v.onMessage}
                    rows="3"
                    style={s("background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.18);border-radius:12px;padding:15px 18px;font-size:16.5px;color:#FFFFFF;outline:none;width:100%;resize:vertical;")}
                  />
                  {' '}
                  <button
                    className="hv-16"
                    type="submit"
                    style={s("background:#FFFFFF;color:#0B1F23;border:none;padding:16px 30px;border-radius:999px;font-size:17px;font-weight:700;margin-top:4px;letter-spacing:-0.01em;cursor:pointer;box-shadow:0 10px 26px rgba(0,0,0,0.22);")}
                  >
                    {v.ctaLabel}
                  </button>
                  {' '}
                </form>
              </>
            ) : null}
            {v.submitted ? (
              <>
                <div
                  style={s("margin:34px auto 0;max-width:540px;display:flex;align-items:center;gap:12px;justify-content:center;background:rgba(122,206,192,0.16);border:1px solid rgba(122,206,192,0.45);border-radius:14px;padding:22px 28px;font-size:17px;line-height:1.5;color:#FFFFFF;")}
                >
                  {' '}
                  <span style={s("flex:0 0 auto;width:8px;height:8px;border-radius:50%;background:#7ACEC0;")} />
                  Thanks — we've got it. We'll be in touch shortly.
                </div>
              </>
            ) : null}
            <div
              style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:13px;letter-spacing:0.06em;color:rgba(234,243,241,0.62);margin-top:22px;")}
            >
              Or reach us at hello@getbrandbase.com
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
